import React, { useMemo, useState } from 'react';
import {
    Grid,
    TextField,
    InputLabel,
    FormControl,
    Select,
    MenuItem,
    IconButton,
    Dialog,
    DialogContent,
    DialogActions,
    DialogTitle,
    DialogContentText,
    Button,
    FormHelperText,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { Box } from '@mui/system';
import { styles } from '../Add/styles';
import majorCategoryIcon from '../../../assets/images/majorCategory.svg';
import minorCategoryIcon from '../../../assets/images/minorCategory.svg';

const MetaFieldForm = (props) => {
    const { index, item, error, touched, masterCustomAttributes, handleChange, setOpenDialog, isClientHqEnabled } =
        props;

    const {
        masterCustomAttribute,
        fieldLabel,
        fieldDataType,
        category,
        isRequired,
        fieldListOptions,
        id,
        original,
        sensitiveInformation,
        visibleOn1Demand,
    } = item;

    return (
        <Box>
            <Grid item container spacing={2} xs={12} pr={3}>
                <Grid item xs={1.9}>
                    <FormControl
                        size="small"
                        fullWidth
                        sx={{
                            minWidth: 120,
                        }}
                        error={Boolean(touched?.['masterCustomAttribute'] && error?.['masterCustomAttribute'])}
                    >
                        <InputLabel id="data-type-label">Master Name</InputLabel>
                        <Select
                            labelId="demo-simple-select-label"
                            id="masterCustomAttribute"
                            name="masterCustomAttribute"
                            value={masterCustomAttribute}
                            label="Master Name"
                            onChange={(event) => handleChange(index, event)}
                        >
                            {[masterCustomAttribute, ...masterCustomAttributes].map((item) => (
                                <MenuItem key={item.id} value={item}>
                                    {item.name}
                                </MenuItem>
                            ))}
                        </Select>
                        {touched?.['masterCustomAttribute'] && (
                            <FormHelperText>{error?.['masterCustomAttribute']}</FormHelperText>
                        )}
                    </FormControl>
                </Grid>
                <Grid item xs={2}>
                    <TextField
                        name="fieldLabel"
                        label="Title"
                        value={fieldLabel}
                        onChange={(event) => handleChange(index, event)}
                        size="small"
                        fullWidth
                        error={Boolean(touched?.['fieldLabel'] && error?.['fieldLabel'])}
                        helperText={touched?.['fieldLabel'] && error?.['fieldLabel']}
                    />
                </Grid>
                <Grid item xs={2}>
                    <FormControl
                        sx={{
                            minWidth: 120,
                        }}
                        size="small"
                        fullWidth
                    >
                        <InputLabel id="data-type-label">Type</InputLabel>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            name="fieldDataType"
                            value={fieldDataType}
                            label="Type"
                            onChange={(event) => handleChange(index, event)}
                        >
                            <MenuItem value="String">Text</MenuItem>
                            <MenuItem value="Integer">Number</MenuItem>
                            <MenuItem value="Date">Date</MenuItem>
                            <MenuItem value="Single Selection List">Single Selection List</MenuItem>
                            <MenuItem value="Multiple Selection List">Multiple Selection List</MenuItem>
                        </Select>
                    </FormControl>
                </Grid>
                {(fieldDataType === 'Single Selection List' || fieldDataType === 'Multiple Selection List') && (
                    <Grid item xs={2}>
                        <TextField
                            sx={{
                                minWidth: 120,
                            }}
                            name="fieldListOptions"
                            label="Values"
                            value={fieldListOptions}
                            onChange={(event) => handleChange(index, event)}
                            size="small"
                            fullWidth
                            error={Boolean(touched?.['fieldListOptions'] && error?.['fieldListOptions'])}
                            helperText={touched?.['fieldListOptions'] && error?.['fieldListOptions']}
                        />
                    </Grid>
                )}
                <Grid item xs={1.9}>
                    <FormControl
                        sx={{
                            minWidth: 120,
                        }}
                        size="small"
                        fullWidth
                    >
                        <InputLabel id="data-type-label">Category</InputLabel>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            name="category"
                            value={category}
                            label="Category"
                            onChange={(event) => handleChange(index, event)}
                        >
                            <MenuItem value="Minor">
                                <img
                                    src={minorCategoryIcon}
                                    alt="Minor"
                                    style={{
                                        paddingRight: '6px',
                                    }}
                                />
                                Minor
                            </MenuItem>
                            <MenuItem value="Major">
                                <img
                                    src={majorCategoryIcon}
                                    alt="Major"
                                    style={{
                                        paddingRight: '6px',
                                    }}
                                />
                                Major
                            </MenuItem>
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={2}>
                    <FormControl
                        sx={{
                            minWidth: 120,
                        }}
                        size="small"
                        fullWidth
                    >
                        <InputLabel id="data-type-label">Is Required?</InputLabel>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            name="isRequired"
                            value={isRequired}
                            label="Is Required?"
                            onChange={(event) => handleChange(index, event)}
                        >
                            <MenuItem value={true}>Mandatory</MenuItem>
                            <MenuItem value={false}>Optional</MenuItem>
                        </Select>
                    </FormControl>
                </Grid>
                {isClientHqEnabled && (
                    <>
                        <Grid item xs={2}>
                            <FormControl
                                sx={{
                                    minWidth: 120,
                                }}
                                size="small"
                                fullWidth
                                error={Boolean(touched?.['sensitiveInformation'] && error?.['sensitiveInformation'])}
                            >
                                <InputLabel id="data-type-label">Sensitive Information</InputLabel>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    name="sensitiveInformation"
                                    value={sensitiveInformation}
                                    label="Sensitive Information"
                                    onChange={(event) => handleChange(index, event)}
                                >
                                    <MenuItem value={true}>Yes</MenuItem>
                                    <MenuItem value={false}>No</MenuItem>
                                </Select>
                                {touched?.['sensitiveInformation'] && (
                                    <FormHelperText>{error?.['sensitiveInformation']}</FormHelperText>
                                )}
                            </FormControl>
                        </Grid>
                        <Grid item xs={2}>
                            <FormControl
                                sx={{
                                    minWidth: 120,
                                }}
                                size="small"
                                fullWidth
                                error={Boolean(touched?.['visibleOn1Demand'] && error?.['visibleOn1Demand'])}
                            >
                                <InputLabel id="data-type-label">Visible on 1Demand</InputLabel>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    name="visibleOn1Demand"
                                    value={visibleOn1Demand}
                                    label="Visible on 1Demand"
                                    onChange={(event) => handleChange(index, event)}
                                >
                                    <MenuItem value={true}>Yes</MenuItem>
                                    <MenuItem value={false}>No</MenuItem>
                                </Select>
                                {touched?.['visibleOn1Demand'] && (
                                    <FormHelperText>{error?.['visibleOn1Demand']}</FormHelperText>
                                )}
                            </FormControl>
                        </Grid>
                    </>
                )}
                {(!id || (typeof original?.isRequired === 'boolean' ? !original?.isRequired : !isRequired)) && (
                    <Grid item xs={0.2}>
                        <IconButton onClick={() => setOpenDialog(index)}>
                            <DeleteIcon />
                        </IconButton>
                    </Grid>
                )}
            </Grid>
            <Box sx={styles.separatorLine} my="30px" />
        </Box>
    );
};

const MetaFields = ({ formik, masterCustomAttributes, handleDelete, handleChange, isClientHqEnabled }) => {
    const [openDialog, setOpenDialog] = useState(null);
    const { values, errors, touched } = formik;

    const filteredMasterCustomAttributes = useMemo(() => {
        const selectedMasterCustomAttributesId = values.map((item) => item.masterCustomAttribute?.id);
        return masterCustomAttributes
            .filter((item) => selectedMasterCustomAttributesId.indexOf(item.id) < 0)
            .map((item) => ({ id: item.id, name: item.attributeName }));
    }, [values, masterCustomAttributes]);

    return (
        <Box>
            <Dialog open={openDialog === null ? false : true} onClose={() => setOpenDialog(null)}>
                <DialogContent>
                    <Box>
                        <DialogTitle sx={styles.dialogTitle}>Delete Custom Attributes</DialogTitle>
                        <DialogContentText>Are you sure you want to delete custom Attributes?</DialogContentText>
                    </Box>
                    <DialogActions sx={styles.buttonsWrapper}>
                        <Button size="large" onClick={() => setOpenDialog(null)}>
                            Cancel
                        </Button>
                        <Button
                            size="large"
                            variant="contained"
                            onClick={() => {
                                handleDelete(openDialog);
                                setOpenDialog(null);
                            }}
                        >
                            Confirm
                        </Button>
                    </DialogActions>
                </DialogContent>
            </Dialog>
            {values.map((item, index) => (
                <MetaFieldForm
                    key={index}
                    index={index}
                    error={errors[index]}
                    touched={touched[index]}
                    item={item}
                    masterCustomAttributes={filteredMasterCustomAttributes}
                    handleChange={handleChange}
                    setOpenDialog={setOpenDialog}
                    isClientHqEnabled={isClientHqEnabled}
                />
            ))}
        </Box>
    );
};

export default MetaFields;
